import { curry } from "lodash/fp"
import { SingleActivityModel } from "services/openapi"

const activityIdEquals = (activityId: number, activity: SingleActivityModel) => {
  return activity.activityId === activityId
}

export default curry(activityIdEquals)
